export default "__VITE_ASSET__BgUwC9ux__"